(function () {
  if (window.__atcQuoteForwardInit) return;
  window.__atcQuoteForwardInit = true;

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.add-to-cart-button');
      if (!button) return;

      const container = button.closest('add-to-cart-component[data-forward-to-quote="true"]');
      if (!container) return;

      const scope =
        button.closest('product-card') ||
        button.closest('product-form-component') ||
        container;
      const quoteButton = scope.querySelector('.omgrfq-btn-quotes');
      if (!quoteButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      quoteButton.click();
    },
    true
  );
})();
